import { LayoutConfig } from '@spartacus/storefront'

export const ebFooterLayoutConfig: LayoutConfig = {
  layoutSlots: {
    footer: {
      slots: [
        'Footer',
        'FooterAboutUs',
        'FooterNavigation',
        'FooterContact',
        'FooterConsent',
        'FooterCopyRight'
      ]
    }
  }
}
